// Third-party Imports
import { createSlice } from '@reduxjs/toolkit'

// Constants
const initialState = {
  selectedAvatar: null
}

export const avatarSlice = createSlice({
  name: 'avatar',
  initialState,
  reducers: {
    storeSelectedAvatarInfo: (state, action) => {
      state.selectedAvatar = action.payload
    }
  }
})

export const { storeSelectedAvatarInfo } = avatarSlice.actions

export default avatarSlice.reducer
